"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enhanceDependencyDataProcessor = void 0;
/* eslint-disable no-param-reassign -- We want to adress envelope directly, because it is a reference to data sent to AI */

const enhanceDependencyDataProcessor = (envelope, context) => {
  if (envelope.data.baseType !== 'RemoteDependencyData') {
    return true;
  }
  const customProps = context?.correlationContext?.customProperties.props;
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain -- Optional chaining is not equevalent to the check below
  if (!customProps || !(customProps.length > 0)) {
    return true;
  }

  // Transform array of key-value pairs into a flat object
  const flattenedProps = Object.fromEntries(customProps.map(property => [property.key, property.value]));

  // Add to dependency properties
  if (Object.keys(flattenedProps).length === 0) {
    return true;
  }
  envelope.data.baseData = {
    ...envelope.data.baseData,
    properties: {
      ...envelope.data.baseData?.properties,
      ...flattenedProps
    }
  };
  return true;
};
exports.enhanceDependencyDataProcessor = enhanceDependencyDataProcessor;
//# sourceMappingURL=enhanceDependencyDataProcessor.js.map